import { Button } from 'antd';
import { FC } from 'react';
import { CategoryRelationFormDataType, Tooltip } from '@atlas-frontend/sdk';
import styled from 'styled-components';

export interface CategoryGroupEntriesProps {
  id: string;
  entries: CategoryRelationFormDataType[];
  onClick?: () => void;
}

export const CategoryGroupEntries: FC<CategoryGroupEntriesProps> = (props) => {
  const { id, entries, onClick } = props;

  const button = (
    <StyledButton
      id={id}
      type="link"
      size="small"
      shape="round"
      onClick={onClick}
    >
      {entries.length}
    </StyledButton>
  );

  if (!entries.length) {
    return button;
  }

  return (
    <Tooltip
      title={entries.map(({ subCategoryName }) => subCategoryName).join(', ')}
      placement="left"
    >
      {button}
    </Tooltip>
  );
};

const StyledButton = styled(Button)`
  margin-block: -1px;
`;
